import React from "react";
import { motion } from "framer-motion";
import { YARNS, YARN_ORDER } from "../lib/yarns";

export default function YarnsExplainer() {
  return (
    <section
      id="yarns"
      className="relative py-24 md:py-32"
      data-testid="yarns-explainer"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14 md:mb-20">
          <p className="text-xs uppercase tracking-[0.22em] text-weave-teal font-medium mb-4">
            The four yarns
          </p>
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-[#1a1a1a] leading-[1.1]">
            Four threads, one weave.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#3a3a3a]/85 leading-relaxed max-w-xl">
            Every pull draws from one of four bodies of work. Each yarn has
            its own voice, its own source, and its own kind of usefulness —
            so the loom never gives you the same Tuesday twice.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {YARN_ORDER.map((key, i) => {
            const yarn = YARNS[key];
            return (
              <motion.div
                key={key}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.08, ease: "easeOut" }}
                className="group relative rounded-2xl p-6 md:p-7 border border-black/5 transition-colors duration-300 hover:shadow-[0_10px_30px_rgba(60,40,10,0.08)]"
                style={{ backgroundColor: yarn.pastel }}
                data-testid={`yarn-card-${key}`}
              >
                <div className="flex items-center justify-between mb-5">
                  <span
                    className="inline-flex items-center justify-center w-10 h-10 rounded-full ring-2"
                    style={{
                      backgroundColor: yarn.deep,
                      borderColor: yarn.accent,
                    }}
                    aria-hidden
                  >
                    <span className="block w-3 h-3 rounded-full" style={{ backgroundColor: yarn.accent }} />
                  </span>
                  <span
                    className="text-[11px] uppercase tracking-[0.2em] font-medium"
                    style={{ color: yarn.accent }}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3
                  className="text-2xl font-semibold text-[#1a1a1a] mb-1.5"
                  style={{ fontFamily: "Rubik, sans-serif" }}
                >
                  {yarn.label}
                </h3>
                <p className="text-xs uppercase tracking-[0.14em] mb-4" style={{ color: yarn.accent }}>
                  {yarn.source}
                </p>
                <p className="text-sm md:text-[15px] leading-relaxed text-[#1a1a1a]/85">
                  {yarn.blurb}
                </p>
                <div className="mt-5 pt-4 border-t border-black/10">
                  <p className="text-xs uppercase tracking-[0.14em] text-[#1a1a1a]/55">
                    What you receive
                  </p>
                  <p className="text-sm font-medium text-[#1a1a1a] mt-1">
                    {yarn.promise}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
